import { type ReactElement } from 'react';
import { NotificationSettingsControl } from '@/components/NotificationSettingsControl';
import { InAppAlertsAggregationControl } from '@/components/InAppAlertsAggregationControl';
import { Section } from '../Section';

type Props = {
  organizationId: string;
};

export function NotificationsSubTab({ organizationId }: Props): ReactElement {
  return (
    <div className="space-y-7">
      <Section
        title="In-App Notifications"
        description="Configure when organization members receive popup notifications for security alerts"
      >
        <NotificationSettingsControl organizationId={organizationId} />
      </Section>
      <Section
        title="In-App Alerts Aggregation"
        description="Control how often in-app security alerts are combined into summary notifications by severity"
      >
        <InAppAlertsAggregationControl organizationId={organizationId} />
      </Section>
    </div>
  );
}
